import React, {useContext, useEffect, useMemo, useState} from 'react';
import {SettlementsContext} from '../../../context/settlements/settlementsContext';
import {SettlementsMonthsTable} from './settlementsMonthTable/SettlementsMonthsTable';
import {Button, Grid, Typography} from '@mui/material';

const Settlements = () => {
    const {settlementsState, getSettlementsDates} = useContext(SettlementsContext);
    const [activeMenu, setActiveMenu] = useState(0);

    const minYear = new Date().getFullYear() - 2;

    const filteredDates = useMemo(() =>
            settlementsState.settlementsDates.filter(([year]) => +year >= minYear),
        [settlementsState.settlementsDates, minYear]
    );

    useEffect(() => {
        void getSettlementsDates();
    }, [getSettlementsDates])

    useEffect(() => {
        if (filteredDates.length) {
            setActiveMenu(filteredDates.length - 1);
        }
    }, [filteredDates])

    if (!filteredDates.length) {
        return (
            <Grid container alignItems="center" justifyContent="center" p={2}>
                <Typography>Brak danych</Typography>
            </Grid>
        );
    }

    return (
        <>
            <Grid container pb={1} sx={{mb: '20px'}}>
                {filteredDates.map(([year], index) =>
                    <Button key={year} onClick={() => setActiveMenu(index)}
                            className={`settlements__nav-item ${activeMenu === index ? 'settlements__nav-activeItem' : ''}`}
                            variant="contained" sx={{
                        marginRight: '16px',
                        padding: '5px 50px'
                    }}>{year}</Button>
                )}
            </Grid>
            {filteredDates[activeMenu][1].length
                ? <SettlementsMonthsTable activeMonths={filteredDates[activeMenu][1]}/>
                : <Typography>Brak danych</Typography>
            }
        </>
    );
}

export default Settlements;
